module.exports = __webpack_public_path__ + "static/img/ent-45.dc1bd37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-45.jpg
// module id = bwi/
// module chunks = 51